// Lib i18n légère pour PharmaConnect.
// Usage : `translate('fr', 'nav.dashboard')` → 'Tableau de bord'
// Variables : `translate('fr', 'hello.name', { name: 'X' })` interpole
// les `{name}` du template.

import { en } from './en'
import { fr } from './fr'

export type Language = 'fr' | 'en'
export const SUPPORTED_LANGUAGES: ReadonlyArray<Language> = ['fr', 'en']

export const LANGUAGE_LABEL: Record<Language, string> = {
  fr: 'Français',
  en: 'English',
}

export const LANGUAGE_FLAG: Record<Language, string> = {
  fr: '🇫🇷',
  en: '🇬🇧',
}

const DICTS = { fr, en } as const

const lookupKey = (
  obj: Record<string, unknown>,
  key: string,
): string | undefined => {
  const parts = key.split('.')
  let cur: unknown = obj
  for (const p of parts) {
    if (typeof cur !== 'object' || cur === null) return undefined
    cur = (cur as Record<string, unknown>)[p]
  }
  return typeof cur === 'string' ? cur : undefined
}

export const translate = (
  lang: Language,
  key: string,
  vars?: Record<string, string | number>,
): string => {
  const value =
    lookupKey(DICTS[lang] as unknown as Record<string, unknown>, key) ??
    lookupKey(DICTS.fr as unknown as Record<string, unknown>, key) ??
    key

  if (!vars) return value
  return value.replace(/\{(\w+)\}/g, (_, k: string) => {
    const v = vars[k]
    return v === undefined ? `{${k}}` : String(v)
  })
}

export const detectBrowserLanguage = (): Language => {
  const nav: { language?: string } | undefined =
    typeof globalThis !== 'undefined'
      ? (globalThis as unknown as { navigator?: { language?: string } }).navigator
      : undefined
  if (!nav) return 'fr'
  const code = (nav.language || 'fr').slice(0, 2).toLowerCase()
  return code === 'en' ? 'en' : 'fr'
}

export { fr, en }
